import React from 'react'
import "./Subtotal.css"
// import FormatCurrency from 'react-format-currency';
// import { IntlProvider} from 'react-intl';
import { useStateValue } from './StateProvider'

import {getBasketTotal} from './reducer';

function Subtotal() {
    let dollarUSLocale = Intl.NumberFormat('en-US');
    const [{ basket }, dispatch] = useStateValue();
    let price = 0;
    if (basket.length !== 0) {
        {
             basket.map(function (element) {
                price += element.price
            })
        }
    }
    return (

        <div className="subtotal">
            <p>Subtotal ({basket.length} items):<strong>Rs.{dollarUSLocale.format(getBasketTotal(basket))}</strong></p>
            <small className="subtotal__gift">
                <input type="checkbox" name="" id="" />This order contains Gift
            </small>
            <button>Proceed to Checkout</button>
        </div>

    )
}

export default Subtotal
